import { render } from "./signature_step.vue?vue&type=template&id=e24dccfe"
import script from "./signature_step.vue?vue&type=script&lang=js"
export * from "./signature_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/signature_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e24dccfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e24dccfe', __exports__)) {
    api.reload('e24dccfe', __exports__)
  }
  
  module.hot.accept("./signature_step.vue?vue&type=template&id=e24dccfe", () => {
    api.rerender('e24dccfe', render)
  })

}


export default __exports__